import { useSnackbar } from 'public/components/Snackbar';

export const useShare = (eventSlug) => {
  const [showShareSuccess, shareSnackbar] = useSnackbar();

  const share = async (ev) => {
    ev.preventDefault();
    ev.stopPropagation();

    try {
      await navigator.clipboard.writeText(
        `${location.origin}/events/${eventSlug}`
      );
      // @ts-ignore
      showShareSuccess(true);
    } catch (error) {
      console.error('Failed to copy text: ', error);
    }
  };

  return { share, shareSnackbar };
};
